function Icon({
  name,
  className = '',
  size,
}: {
  name: string
  className?: string
  size?: string
}) {
  return (
    <i
      className={`las la-${name} ${className}`}
      style={{ fontSize: size ?? '12px' }}
    ></i>
  )
}

export default Icon
